import { Inject, Injectable } from "@angular/core";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { CpesActionsService } from "@nms-ng2/app/shared/services/actions/cpes-actions.service";
import { CUSTOM_SVG } from "@nms-ng2/app/shared/constants/svg";
import { DropdownShortcut } from "@nms-angular-toolkit/nms-dropdown";

/**
 * Serviço responsável por retornar os shortcuts relacionados ao CPE
 * Foi necessária a criação desse serviço, pois a chamada da funcionalidade openDeviceCpeFn é um pouco diferente
 * na nova tela de GPON-ONUS.
 */
@Injectable({
    providedIn: "root"
})
export class CpeDropdownService {

    private readonly ERROR_MESSAGE_KEY = "gpon.onus.onuNotRegistered";

    constructor(@Inject(ANGULARJS_TRANSLATE) public readonly translate,
                private readonly cpesActionsService: CpesActionsService) {
    }

    getTR069Shortcuts = (openDeviceCpeFn) => {
        const hasCpeLastInform = (cpe) => !_.isArray(cpe) && _.isEmpty(cpe.cwmpCpeLastInform);

        return [
            {
                label: this.translate.instant("title.deviceConfiguration"),
                action: (cpe) => openDeviceCpeFn.call(null, cpe),
                hasDivider: true,
                isVisible: (cpe) => !_.isArray(cpe),
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.parameters"),
                action: (cpes) => this.cpesActionsService.tryToOpenParametersModalForCpes(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                icon: "settings"
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.applyTemplate"),
                action: (cpes) => this.cpesActionsService.goToTemplateApplication(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                customSvgIcon: CUSTOM_SVG.applyTemplate
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.viewTemplateApplication"),
                action: (cpes) => this.cpesActionsService.viewTemplateApplication(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                customSvgIcon: CUSTOM_SVG.viewTemplateApplication
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.credentials"),
                action: (cpes) => this.cpesActionsService.tryToCredentialsModalCpes(cpes),
                icon: "lock_open"
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.testConnectivity"),
                action: (cpes) => this.cpesActionsService.tryToOpenConnectivityTestModalForCpes(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                icon: "repeat"
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.download"),
                action: (cpes) => this.cpesActionsService.tryToOpenDownloadRequestModal(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                icon: "download"
            },
            {
                label: this.translate.instant("gpon.cpes.tableActions.tr069.reboot"),
                action: (cpes) => this.cpesActionsService.tryToRebootCpes(cpes),
                isShortcutDisabled: hasCpeLastInform,
                disabledShortcutTooltip: this.translate.instant(this.ERROR_MESSAGE_KEY),
                icon: "restart_alt"
            }
        ] as DropdownShortcut[];
    }
}
